import React, { MutableRefObject, useCallback, useState } from 'react'
import { MODEL_TYPE } from '@trustero/trustero-api-web/lib/common/model_pb'
import { GRC_PLATFORM } from '@trustero/trustero-api-web/lib/common/grc_platform_pb'
import { FlexAlign, FlexColumn, FlexRow } from '../Reusable/Flex'
import { CheckBoxInput } from '../Reusable/Inputs/CheckBox'
import { getGrcPlatformLabel, getModelTypeLabel } from './ModalForm.utils'

export const ImportedRecordModalBody = ({
  modelType,
  grcPlatform,
  dismissWarning,
  setDismissWarning,
}: {
  modelType: MODEL_TYPE
  grcPlatform: GRC_PLATFORM
  dismissWarning: MutableRefObject<boolean>
  setDismissWarning: (value: boolean) => void
}): JSX.Element => {
  const modelTypeLabel = getModelTypeLabel(modelType)
  const grcPlatformLabel = getGrcPlatformLabel(grcPlatform)
  const [checked, setChecked] = useState<boolean>(dismissWarning.current)

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setDismissWarning(e.target.checked)
      setChecked(e.target.checked)
    },
    [setDismissWarning],
  )

  return (
    <FlexColumn gap={10} align={FlexAlign.FLEX_START}>
      {`This ${modelTypeLabel} has been imported from ${grcPlatformLabel}. 
      If it changes in ${grcPlatformLabel} and is imported again, the version in ${grcPlatformLabel} will replace any changes you make here in Trustero.`}
      <FlexRow justify={FlexAlign.FLEX_START} gap={10}>
        <CheckBoxInput checked={checked} onChange={handleChange} />
        Don&apos;t show this warning again
      </FlexRow>
    </FlexColumn>
  )
}
